import React, { useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
var axios = require("axios");
const Login = () => {
  const history = useHistory();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const handleSubmit = () => {
      var fdata = new FormData();
      fdata.append("username", email);
      fdata.append("password", password);
      axios({
        method: "post",
        url: 'http://112.133.197.42/API/login.php',
        data: fdata,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          console.log(response)
          if(response.data.error==="Invalid username or password"){
            toast.error('Username or Password are incorrect !', { position: toast.POSITION.TOP_RIGHT });
          }else{
            toast.success('Login Succesfull !', { position: toast.POSITION.TOP_RIGHT });
            localStorage.setItem('token', response.data.token);
            window.location.reload(); 
          }
          
        })
        .catch(function (response) {
     });
    };
    const register=()=>{
      history.push('/register');
    }
  return (
    <Logins>
    <div className="Auth-form-container">
        <div className="Auth-form">
          <div className="Auth-form-content">
            <h3 className="Auth-form-title">Sign In</h3>
            <div className="form-group mt-3">
              <label>Username/Email</label>
              <input
                type="email"
                className="form-control mt-1"
                placeholder="Enter email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>
            <div className="form-group mt-3">
              <label>Password</label>
              <input
                type="password"
                className="form-control mt-1"
                placeholder="Enter password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>
            <div className="d-grid gap-2 mt-3">
              <button type="submit" className="btn btn-primary" onClick={()=>{handleSubmit()}}>
                Submit
              </button>
            </div>
            <ToastContainer />

            <p className="text-center mt-2">
              Forgot <a href="#">password?</a>
            </p>
            <p className="text-center mt-2">
              Don't Have Account <a href="#" onClick={register}>Register with us</a>
            </p>
          </div>
        </div>
      </div>
      </Logins>
  )
}

export default Login

const Logins = styled.div`

 .App {
    background-color: white;
  }
  
  .Auth-form-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
  }
  
  .Auth-form {
    width: 420px;
    box-shadow: rgb(0 0 0 / 16%) 1px 1px 10px;
    padding-top: 30px;
    padding-bottom: 20px;
    border-radius: 8px;
    background-color: white;
  }
  
  .Auth-form-content {
    padding-left: 12%;
    padding-right: 12%;
  }
  
  .Auth-form-title {
    text-align: center;
    margin-bottom: 1em;
    font-size: 24px;
    color: rgb(34, 34, 34);
    font-weight: 800;
  }
  
  label {
    font-size: 14px;
    font-weight: 600;
    color: rgb(34, 34, 34);
  }
`